import { render, staticRenderFns } from "./blogComponent.vue?vue&type=template&id=37810b8c&scoped=true"
import script from "./blogComponent.vue?vue&type=script&lang=js"
export * from "./blogComponent.vue?vue&type=script&lang=js"
import style0 from "./blogComponent.vue?vue&type=style&index=0&id=37810b8c&prod&lang=scss&scoped=true"
import style1 from "./blogComponent.vue?vue&type=style&index=1&id=37810b8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37810b8c",
  null
  
)

export default component.exports